import { z } from 'zod/v4';
import { EZipCodeValidation } from './countries.enum';

export interface ICountry {
  guid: string;
  isoCode: string;
  name: string;
  onlineRegistration: boolean;
  zipCodeValidation: EZipCodeValidation;
  sepaProcedure: boolean;
}

export const COUNTRY_SCHEMA: z.ZodType<ICountry> = z.object({
  guid: z.string(),
  isoCode: z.string(),
  name: z.string(),
  onlineRegistration: z.boolean(),
  zipCodeValidation: z.enum(EZipCodeValidation),
  sepaProcedure: z.boolean(),
});

export const COUNTRIES_SCHEMA: z.ZodType<ICountry[]> = z.array(COUNTRY_SCHEMA);
